<template>
  <div>
    <v-navigation-drawer v-model="drawer" :clipped="$vuetify.breakpoint.lgAndUp" app>
      <v-list nav dense>
        <v-subheader>PERFIL DO ALUNO</v-subheader>
        <v-list-item color="primary">
          <v-list-item-content>
            <v-list-item-title class="title">{{ this.user.name.replace(/ .*/,'') }}</v-list-item-title>
          </v-list-item-content>
          <v-list-item-action>
            <v-btn rounded text @click="doLogout" color="primary">
              Sair
              <v-icon>mdi-logout</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar :clipped-left="$vuetify.breakpoint.lgAndUp" app color="blue darken-3" dark>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>

      <v-toolbar-title style="width: 300px" class="ml-0 pl-2">
        <strong class="font-weight-medium text-no-wrap">Check-in de Aula</strong>
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <div class="font-weight-thin text-caption text-no-wrap">
        {{ this.currentUnit.idPolinex }} -
        {{ this.currentUnit.name }}
      </div>
      <v-progress-linear
        :active="true"
        :indeterminate="true"
        absolute
        bottom
        color="primary lighten-2"
        v-if="loading"
      ></v-progress-linear>
    </v-app-bar>

    <v-main class="fill-height" fluid>
      <transition name="fade" mode="out-in">
        <router-view name="navigation"></router-view>
      </transition>
    </v-main>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "Member",
  components: {},
  data: () => ({
    loading: true,
    drawer: false
  }),
  mounted() {
    this.loading = true;
    this.ActionSetCurrentUnit(this.user.unit);
    if (this.$router.currentRoute.name !== "member/class-schedules")
      this.$router.push({ name: "member/class-schedules" });

    this.loading = false;
  },
  watch: {},
  methods: {
    ...mapActions("auth", ["ActionSignOut"]),
    ...mapActions("units", ["ActionGetCurrentUnit", "ActionSetCurrentUnit"]),

    async doLogout() {
      try {
        await this.ActionSignOut();
        this.$router.push({ name: "login" });
      } catch (err) {
        console.log(err);
      }
      this.group();
    },
    async setCurrentUnit(unit) {
      await this.ActionSetCurrentUnit(unit);
    },
    group() {
      this.drawer = false;
    }
  },
  computed: {
    ...mapState("auth", ["user"]),
    ...mapState("units", ["currentUnit"])
  }
};
</script>
<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
